module.exports = __webpack_public_path__ + "img/titles13.047de582.png";